/* Wizard kiwi variant — pointy hat with star. */

import type { KiwiPalette } from "../kiwiPalettes";

export function renderWizard(p: KiwiPalette) {
  return (
    <>
      {/* Wizard hat */}
      <path d="M16 0H18V2H16V0ZM14 2H20V4H14V2ZM12 4H22V6H12V4ZM10 6H24V8H10V6Z" fill={p.accent} opacity={0.5} />
      {/* Star on hat */}
      <rect x="17" y="2" width="2" height="2" fill={p.accent} opacity={0.3} />
      {/* Body */}
      <path d="M12 8H20V10H24V12H26V18H24V22H20V24H12V22H8V18H6V12H8V10H12V8Z" fill={p.body} />
      {/* Highlight */}
      <rect x="20" y="12" width="2" height="2" fill={p.highlight} opacity={0.3} />
      {/* Beak */}
      <path d="M4 14H6V16H4V14ZM2 16H4V18H2V16ZM2 18H4V20H2V18ZM4 20H6V22H4V20Z" fill={p.beak} />
      {/* Eye */}
      <rect x="10" y="12" width="6" height="6" fill={p.eyeBg} />
      <rect x="12" y="14" width="2" height="2" fill={p.pupil} />
      {/* Feet */}
      <path d="M12 24H14V28H12V24ZM10 28H16V30H10V28Z" fill={p.body} />
      <path d="M18 24H20V28H18V24ZM16 28H22V30H16V28Z" fill={p.body} />
    </>
  );
}
